import { z } from "zod";

const buttonSchema = z.object({
  text: z.string().min(1, "Button text is required"),
  url: z.string().url("Must be a valid URL"),
  enabled: z.boolean(),
});

export const buildSchema = z
  .object({
    hasProfileHeader: z.boolean(),
    hasIntroduction: z.boolean(),
    introductionText: z.string(),
    buttons: z.array(buttonSchema),
    hasGallery: z.boolean(),
    galleryTitle: z.string(),
    galleryId: z.string(),
    galleryRedirect: z.boolean(),
    galleryDefaultRedirectUrl: z.string(),
    hasRedirect: z.boolean(),
    redirectUrl: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.hasRedirect && data.redirectUrl) {
      try {
        new URL(data.redirectUrl);
      } catch {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Must be a valid URL",
          path: ["redirectUrl"],
        });
      }
    }
    if (data.hasGallery && data.galleryDefaultRedirectUrl) {
      try {
        new URL(data.galleryDefaultRedirectUrl);
      } catch {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Must be a valid URL",
          path: ["galleryDefaultRedirectUrl"],
        });
      }
    }
  });

/** What the form's controlled inputs hold. */
export type BuildFormInput = z.input<typeof buildSchema>;
/** What the resolver / submit handler receive. */
export type BuildFormValues = z.output<typeof buildSchema>;
